var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"service","label":_vm.$t('servico')}}),_c('el-table-column',{attrs:{"prop":"type","label":_vm.$t('tipo')}}),_c('TableColumnButton',{on:{"edit":_vm.edit,"remove":_vm.remove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }